/* eslint-disable import/prefer-default-export */

import {
  DEFAULT_ENGLISH_GOOGLE_VALUE,
  DEFAULT_LANGUAGE_ENGLISH,
  GOOGLE_TRANSLATE_COOKIE_KEY,
  GOOGLE_TRANSLATE_COOKIE_OPTIONS,
  GOOGLE_TRANSLATE_COOKIE_DOMAINS,
  INITIAL_LANGUAGE,
  LANGUAGE_OPTIONS,
  SUPPORTED_HUMAN_LANGUAGES,
} from 'components/Common/GoogleTranslateV2/constants';

export const handleSetLanguage = ({
  val,
  i18n,
  setSelectedLanguage,
  removeCookie,
  setCookie,
  cookies,
  selectedLanguage,
}) => {
  if (selectedLanguage?.value === val?.value) {
    return;
  }
  // Remove all existing googtrans cookies
  GOOGLE_TRANSLATE_COOKIE_DOMAINS.forEach(domain => {
    // Remove with standard options
    removeCookie(GOOGLE_TRANSLATE_COOKIE_KEY, {
      ...GOOGLE_TRANSLATE_COOKIE_OPTIONS,
      domain,
    });

    // Also try without expiration
    removeCookie(GOOGLE_TRANSLATE_COOKIE_KEY, {
      path: '/',
      domain,
    });
  });

  // Also try removing without domain specification
  removeCookie(GOOGLE_TRANSLATE_COOKIE_KEY, {
    ...GOOGLE_TRANSLATE_COOKIE_OPTIONS,
  });

  // Reset selected language on clear
  if (!val) {
    i18n.changeLanguage(DEFAULT_LANGUAGE_ENGLISH);
    setSelectedLanguage(INITIAL_LANGUAGE);
    if (cookies[GOOGLE_TRANSLATE_COOKIE_KEY]) {
      setCookie(GOOGLE_TRANSLATE_COOKIE_KEY, DEFAULT_ENGLISH_GOOGLE_VALUE, {
        ...GOOGLE_TRANSLATE_COOKIE_OPTIONS,
        encode: v => v,
      });
      window.location.reload();
    }
    return;
  }

  // Use i18n for languages that we support
  if (val && SUPPORTED_HUMAN_LANGUAGES.includes(val.value)) {
    setSelectedLanguage(val);
    i18n.changeLanguage(val.value);
    setCookie(GOOGLE_TRANSLATE_COOKIE_KEY, `/en/${val.value}`, {
      ...GOOGLE_TRANSLATE_COOKIE_OPTIONS,
      encode: v => v,
    });
    return;
  }

  // For unsupported languages, set default language back to English and use Google Translate
  i18n.changeLanguage(DEFAULT_LANGUAGE_ENGLISH);
  setCookie(GOOGLE_TRANSLATE_COOKIE_KEY, `/en/${val.value}`, {
    ...GOOGLE_TRANSLATE_COOKIE_OPTIONS,
    encode: v => v,
  });
  setSelectedLanguage(LANGUAGE_OPTIONS.find(opt => opt.value === val.value));
  window.location.reload();
};
